import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  isInitializing: true,
  interval: null,
};
const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_INTERVAL] = (state, action) =>
  update(state, {
    interval: { $set: action.interval },
  });

switchMap[types.SET_INITIAL_DATA] = (state, action) =>
  update(state, {
    $merge: {
      isInitializing: false,
      interval: action.payload.interval,
    },
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
